// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"860":"9d0f3eec","910":"1207989c"}[chunkId] + ".chunk.css";
};